import React, {useCallback, useState, useEffect} from "react";
import {QueryClient, QueryClientProvider} from "react-query";
import {useNavigate} from "react-router-dom";
import {Delete, Edit} from "@mui/icons-material";
import {SystemRoutes} from "../../../Utils/RouteUtils";
import {HeaderMenu} from "../HeaderMenu";
import {useAppSelector} from "../../../Config/Hooks";
import {hasPermission} from "../../../Shared/Auth/AuthenticationUtil";
import {AUTHORITIES} from "../../../Config/Constants";
import {extractFiltersFromColumns} from "../../../Utils/DataUitils";
import {Box, Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {ACard, ADataGrid, ADataGridColumn, ADataGridFilter, PagedSearchParams} from "@atiautomacao/ati-ui-library";
import {TicketCategory} from "../../../Shared/Types/TicketCategory";
import {SearchTicketCategory} from "./TicketCategoryReactQuery";

const initColumns = [
    {
        name: 'name',
        label: 'Nome',
        align: 'left',
        visibility: true,
        minWidth: 100,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        },
        filter: {name: 'name', condition: 'contains', value: '', sort: 'asc'}

    },
] as ADataGridColumn [];

type ActionConfig = {
    actionName: string;
    disabled: boolean;
};

interface TicketCategoryRow {
    name: string;
    actionsConfig?: Array<ActionConfig>;
}

function TicketCategoryHome() {
    const navigate = useNavigate();

    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToSave = hasPermission(account?.authoritySet, [ AUTHORITIES.SYSADMIN, AUTHORITIES.UPDATE_TICKET_CATEGORY ]);
    const isAuthorizedToDelete = hasPermission(account?.authoritySet, [ AUTHORITIES.SYSADMIN, AUTHORITIES.DELETE_TICKET_CATEGORY ]);

    const [pagedSearchParams, setPagedSearchParams] = useState(new PagedSearchParams(extractFiltersFromColumns(initColumns), 0, 50));
    const handleOnFiltersChange = useCallback((dataGridFilters: Array<ADataGridFilter>, page: number, pageSize: number) => {
        let newPageParams: PagedSearchParams = new PagedSearchParams(dataGridFilters, page, pageSize);
        setPagedSearchParams(
            newPageParams
        );
    }, []);

    const [selectedToDelete, setSelectedToDelete] = useState<any>(null);
    const [totalOfRecords, setTotalOfRecords] = useState(0);
    const [rows, setRows] = useState<Array<TicketCategoryRow>>([]);
    const [openDialog, setOpenDialog] = useState(false);

    const { data, isSuccess } = SearchTicketCategory(pagedSearchParams);

    useEffect(() => {
        if (isSuccess) {
            setTotalOfRecords(data?.data.length);
            if (data?.data) {
                let rows = data.data.map((entity: TicketCategory) => {
                    return {
                        id: entity.id,
                        name: entity.name,
                        actionsConfig: [
                            {actionName: "edit", disabled: !isAuthorizedToSave},
                            {actionName: "delete", disabled: !isAuthorizedToDelete}
                        ]
                    };
                });
                setRows(rows);
            }
        }
    }, [data]);

    const handleEdit = useCallback((data: any) => {
        navigate(SystemRoutes.SETTINGS_TICKET_CATEGORY_FORM, { state: { id: data.id } });
    }, [navigate]);

    const handleDelete = useCallback((data: any) => {

    }, []);

    return(
        <>
            <HeaderMenu systemRoutes={SystemRoutes.SETTINGS_TICKET_CATEGORY_FORM} disableSave={!hasPermission(account?.authoritySet, [ AUTHORITIES.SYSADMIN, AUTHORITIES.SAVE_TICKET_CATEGORY ])}/>
            <ACard>
                <ADataGrid
                    hideFilters={false}
                    showFilterOptions={false}
                    hideSelection={false}
                    columns={initColumns}
                    loading={false}
                    rows={rows}
                    page={pagedSearchParams.page}
                    rowsPerPage={pagedSearchParams.size}
                    totalOfRecords={totalOfRecords}
                    onFiltersChange={handleOnFiltersChange}
                    actions={
                        <>
                           <IconButton name="edit" size={"small"} aria-label="Edit" disabled={!isAuthorizedToSave} onClick={handleEdit}>
                               <Tooltip title="Editar">
                                   <Edit/>
                               </Tooltip>
                           </IconButton>
                           <IconButton name="delete" size={"small"} aria-label="Delete" disabled={!isAuthorizedToDelete} onClick={handleDelete}>
                               <Tooltip title="Excluir">
                                   <Delete />
                               </Tooltip>
                           </IconButton>
                        </>
                    }
                />
            </ACard>
        </>
    )
}

export default function TicketCategoryHomePage() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <TicketCategoryHome />
        </QueryClientProvider>
    )
}